export enum GamificationPages {
    MarketplaceManagementPM = 'PointStoreProduct',
    MarketplaceManagementCXOne = 'PointStoreProductCXOne',
    AwardsTabPM = 'GamificationAwardsTab',
    AwardsTabCXOne = 'AdminAwardsTab',
    GamesTabPM = 'GamificationGamesTab',
    GamesTabCXOne = 'AdminGamesTab',
    BudgetTabPM = 'GamificationBudgetTab',
    BudgetTabCXOne = 'AdminBudgetTab',
    ChallengesTabPM = 'GamificationChallengesTab',
    ChallengesTabCXOne = 'AdminChallengesTab',
    OrderManagementCXOne = 'OrderManagementCXOne',
    MarketPlace = 'Marketplace'
}

export enum AliasPageName {
    MarketplaceManagement = 'marketplaceManagement',
    GamesTab = 'gamesTab',
    AwardsTab = 'awardsTab',
    BudgetTab = 'budgetTab',
    ChallengesTab = 'challengesTab',
    OrderManagement = 'orderManagement',
    Marketplace = 'marketplace'
}
